import './ButtonLink.css';

export function ButtonLink({ href, children, variant = 'primary', className = '', ...props }) {
  return (
    <a className={`button-link button-link--${variant} ${className}`.trim()} href={href} {...props}>
      {children}
    </a>
  );
}
